import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/X.svg'

export const IconX = IconSVG as IconComponent
